"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "~/lib/utils";
import { useNavAuthStore } from "~/store/navAuthStore";

/**
 * The menu trigger, below `md` only. Signed in it stays the name pill it has
 * always been, with the unread dot; signed out it is a bare icon beside the
 * CTAs. Both live in the actions slot rather than the shell because which one
 * to render is an auth question.
 */
export function MobileMenuTrigger(t0) {
  const $ = _c(21);
  const {
    name,
    unreadMessages: t1
  } = t0;
  const unreadMessages = t1 === undefined ? 0 : t1;
  const open = useNavAuthStore(_temp);
  const setSidebarOpen = useNavAuthStore(_temp2);
  let t2;
  if ($[0] !== open || $[1] !== setSidebarOpen) {
    t2 = () => setSidebarOpen(!open);
    $[0] = open;
    $[1] = setSidebarOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const toggle = t2;
  let t3;
  if ($[3] !== unreadMessages) {
    t3 = unreadMessages > 0 && <><span aria-hidden={true} className="absolute -right-0.5 -top-0.5 size-2.5 rounded-full bg-(--blue) ring-2 ring-white" /><span className="sr-only">{" "}— {unreadMessages} unread message{unreadMessages === 1 ? "" : "s"}</span></>;
    $[3] = unreadMessages;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const unreadDot = t3;
  if (name) {
    let t4;
    if ($[5] !== open) {
      t4 = <AnimatedMenuIcon open={open} />;
      $[5] = open;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== name || $[8] !== open || $[9] !== t4 || $[10] !== toggle || $[11] !== unreadDot) {
      t5 = <button type="button" onClick={toggle} aria-expanded={open} className="relative ml-2 flex items-center gap-3 rounded-(--r-full) border border-(--ink-20) bg-white px-4 py-2 font-ui text-sm font-semibold [transition:background-color_var(--dur-fast)_var(--ease-snap)] hover:bg-(--ink-05) md:hidden">{name}{t4}{unreadDot}</button>;
      $[7] = name;
      $[8] = open;
      $[9] = t4;
      $[10] = toggle;
      $[11] = unreadDot;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  const t4 = open ? "Close menu" : "Open menu";
  let t5;
  if ($[13] !== open) {
    t5 = <AnimatedMenuIcon open={open} standalone={true} />;
    $[13] = open;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== open || $[16] !== t4 || $[17] !== t5 || $[18] !== toggle || $[19] !== unreadDot) {
    t6 = <button type="button" onClick={toggle} aria-label={t4} aria-expanded={open} className="relative ml-2 flex size-9 shrink-0 items-center justify-center rounded-(--r-full) [transition:background-color_var(--dur-fast)_var(--ease-snap)] hover:bg-(--ink-05) md:hidden">{t5}{unreadDot}</button>;
    $[15] = open;
    $[16] = t4;
    $[17] = t5;
    $[18] = toggle;
    $[19] = unreadDot;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}
function _temp2(s_0) {
  return s_0.setSidebarOpen;
}
function _temp(s) {
  return s.sidebarOpen;
}
function AnimatedMenuIcon(t0) {
  const $ = _c(19);
  const {
    open,
    standalone: t1
  } = t0;
  const standalone = t1 === undefined ? false : t1;
  const up = standalone ? "-translate-y-[5px]" : "-translate-y-1";
  const down = standalone ? "translate-y-[5px]" : "translate-y-1";
  const t2 = standalone ? "size-5" : "size-4";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("relative flex flex-col items-center justify-center", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = open ? "rotate-45" : up;
  let t5;
  if ($[2] !== t4) {
    t5 = cn("absolute h-[1.5px] w-full rounded-full bg-body transition-all duration-300 ease-in-out", t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t5) {
    t6 = <span className={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = open ? "opacity-0 scale-x-0" : "opacity-100";
  let t8;
  if ($[6] !== t7) {
    t8 = cn("absolute h-[1.5px] w-full rounded-full bg-body transition-all duration-200 ease-in-out", t7);
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t8) {
    t9 = <span className={t8} />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = open ? "-rotate-45" : down;
  let t11;
  if ($[10] !== t10) {
    t11 = cn("absolute h-[1.5px] w-full rounded-full bg-body transition-all duration-300 ease-in-out", t10);
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11) {
    t12 = <span className={t11} />;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t12 || $[15] !== t3 || $[16] !== t6 || $[17] !== t9) {
    t13 = <div className={t3}>{t6}{t9}{t12}</div>;
    $[14] = t12;
    $[15] = t3;
    $[16] = t6;
    $[17] = t9;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  return t13;
}